import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import UploadIcon from "../../Assets/img/upload.png";
import CharIcon from "../../Assets/img/word.png";
import API from "../Service/Baseservice";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../About/Aboutus.css";
import Loading from "../../Loading/loading";
import AboutUsPreview from "./AboutUsPreview";
const AboutUsEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const aboutIdMap = {
        1: 5,  // English
        2: 10 // French
    };
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get("lang");

    const [languageId, setLanguageId] = useState(lang ? Number(lang) : 1);
    const [loading, setLoading] = useState(true);
    const [showPreviewAboutUs, setShowPreviewAboutUs] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [imageFile1, setImageFile1] = useState(null);
    const [imageFile2, setImageFile2] = useState(null);
    const [imagePreview1, setImagePreview1] = useState(null);
    const [imagePreview2, setImagePreview2] = useState(null);

    const [formData, setFormData] = useState({
        aboutus_id: "",
        language_id: languageId,
        about_id: "",
        heading: "",
        description: "",
        image1: "",
        image2: "",
        status: "active",
        updatedBy: 1,
        aboutusData: []
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html || "";
        return (div.textContent || div.innerText || "").length;
    };

    useEffect(() => {
        setLoading(true);

        const payload = {
            language_id: languageId,
            about_id: aboutIdMap[languageId]
        };

        API.post("about_listview/condition", payload)
            .then((res) => {
                const data = res.data?.data;

                if (!data || !data.about_list || data.about_list.length === 0) {


                    setFormData({
                        aboutus_id: id,
                        language_id: languageId,
                        about_id: aboutIdMap[languageId],

                        heading: "",
                        description: "",
                        image1: "",
                        image2: "",

                        status: "active",
                        updatedBy: 1,

                        aboutusData: data?.about_titles?.map((t) => ({
                            aboutustitle_id: t.aboutustitle_id,
                            heading: t.heading,
                            description: t.description
                        })) || []
                    });
                    setImagePreview1(null);
                    setImagePreview2(null);

                    setLoading(false);
                    return;
                }

                const aboutMain = data.about_list[0];

                if (aboutMain.image1) setImagePreview1(aboutMain.image1);
                if (aboutMain.image2) setImagePreview2(aboutMain.image2);

                setFormData({
                    aboutus_id: aboutMain.aboutus_id,
                    language_id: aboutMain.language_id,
                    about_id: aboutMain.about_id,
                    heading: aboutMain.heading,
                    description: aboutMain.description,
                    image1: aboutMain.image1,
                    image2: aboutMain.image2,
                    status: aboutMain.status,
                    updatedBy: 1,

                    aboutusData: data.about_titles.map((t) => ({
                        aboutustitle_id: t.aboutustitle_id,
                        heading: t.heading,
                        description: t.description
                    }))
                });
            })
            .finally(() => setLoading(false));

    }, [id, languageId]);

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleTitleChange = (index, field, value) => {
        const updated = [...formData.aboutusData];
        updated[index][field] = value;
        setFormData({ ...formData, aboutusData: updated });
    };

    const handleImage1Upload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile1(file);
            setImagePreview1(URL.createObjectURL(file));
        }
    };

    const handleImage2Upload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile2(file);
            setImagePreview2(URL.createObjectURL(file));
        }
    };

    const handleUpdate = async () => {
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info"
            });
        }

        if (getPlainTextLength(formData.description) === 0) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Main description is required!",
                type: "info"
            });
        }

        if (formData.aboutusData[0] && !formData.aboutusData[0].heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Vision Title 1 is required!",
                type: "info"
            });
        }

        if (formData.aboutusData[1] && !formData.aboutusData[1].heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Vision Title 2 is required!",
                type: "info"
            });
        }

        setLoading(true);

        const uploadImage = (file) => {
            return new Promise((resolve) => {
                if (!file) return resolve(null);

                const reader = new FileReader();
                reader.onloadend = () => {
                    API.post("imageUpload/add", {
                        name: file.name,
                        image: [{
                            name: file.name,
                            type: file.type,
                            size: `${file.size} bytes`,
                            base64: reader.result
                        }]
                    }).then((res) => resolve(res.data.url))
                        .catch(() => resolve(null));
                };
                reader.readAsDataURL(file);
            });
        };

        const [img1Url, img2Url] = await Promise.all([
            uploadImage(imageFile1),
            uploadImage(imageFile2)
        ]);

        const finalPayload = {
            aboutus_id: formData.aboutus_id,
            language_id: languageId,
            about_id: aboutIdMap[languageId],
            heading: formData.heading,
            description: formData.description,
            image1: img1Url || formData.image1,
            image2: img2Url || formData.image2,
            status: formData.status,
            updatedBy: 1,
            aboutusData: formData.aboutusData
        };

        API.post("aboutus_edit/update", finalPayload)
            .then((res) => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: "Updated successfully!",
                    type: "success"
                });

                // setTimeout(() => navigate("/aboutus"), 1500);
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Something went wrong!",
                    type: "error"
                })
            )
            .finally(() => setLoading(false));
    };

    const handlePreview = () => {

        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Heading is required for preview.",
                type: "info",
            });
        }

        if (getPlainTextLength(formData.description) === 0) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Main description is required for preview.",
                type: "info",
            });
        }

        if (!formData.aboutusData[0]?.heading?.trim()) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Vision title is required for preview.",
                type: "info",
            });
        }

        if (getPlainTextLength(formData.aboutusData[0]?.description) === 0) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Vision description is required for preview.",
                type: "info",
            });
        }

        if (!formData.aboutusData[1]?.heading?.trim()) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Value title is required for preview.",
                type: "info",
            });
        }

        if (getPlainTextLength(formData.aboutusData[1]?.description) === 0) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Value description is required for preview.",
                type: "info",
            });
        }

        if (!imagePreview1 && !imagePreview2) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Please upload at least one image before preview.",
                type: "info",
            });
        }

        const previewPayload = {
            heading: formData.heading,
            description: formData.description,

            visionTitle: formData.aboutusData[0]?.heading,
            visionDescription: formData.aboutusData[0]?.description,

            valueTitle: formData.aboutusData[1]?.heading,
            valueDescription: formData.aboutusData[1]?.description,

            image1: imagePreview1 || formData.image1,
            image2: imagePreview2 || formData.image2,

            preview: true
        };

        setPreviewData(previewPayload);
        setShowPreviewAboutUs(true);
    };


    return (
        <div className="newss-containeradd">

            <div className="service-header-bar">
                <h2 className="services-title1">Edit About Us</h2>

                <div className="button-group">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                value={languageId}
                                className="input-field"
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    const newAboutId = aboutIdMap[newLang];

                                    setLanguageId(newLang);

                                    navigate(`/aboutusedit/${newAboutId}?lang=${newLang}`);
                                }}

                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button
                        className="language-save-btn"
                        onClick={handleUpdate}
                    >
                        Save
                    </button>

                    <button
                        style={{ marginTop: "24px" }}
                        onClick={() => navigate("/aboutus")}
                        className="cancel-btn "
                    >
                        Back
                    </button>
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* FORM */}
                    <div className="aboutus-container">

                        <div className="aboutus-form-group full-width">
                            <label>Heading <span className="required">*</span></label>
                            <input
                                type="text"
                                name="heading"
                                value={formData.heading}
                                onChange={handleChange}
                            // maxLength={70}
                            />
                        </div>

                        <div className="aboutus-flex">

                            {/* LEFT */}
                            <div className="aboutus-left">

                                {/* MAIN DESCRIPTION */}
                                <div className="news-form-group aboutus-editor-small">
                                    <label>
                                        Description <span className="required">*</span>
                                    </label>

                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={formData.description}
                                        onChange={(e, editor) =>
                                            setFormData({ ...formData, description: editor.getData() })
                                        }
                                        config={{
                                            toolbar: [
                                                "undo", "redo", "|",
                                                "heading", "|",
                                                "bold", "italic", "underline", "|",
                                                "bulletedList", "numberedList",
                                            ],
                                        }}
                                    />
                                </div>

                                {/* TITLE 1 */}
                                {formData.aboutusData[0] && (
                                    <div className="news-form-group aboutus-editor-small">
                                        <div className="aboutus-form-group">
                                            <label>Our Vision<span className="required">*</span></label>
                                            <input
                                                style={{ width: "auto" }}
                                                type="text"
                                                value={formData.aboutusData[0].heading}
                                                onChange={(e) =>
                                                    handleTitleChange(0, "heading", e.target.value)
                                                }
                                            />
                                        </div>
                                        <label>Description <span className="required">*</span></label>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={formData.aboutusData[0].description}
                                            onChange={(e, editor) =>
                                                handleTitleChange(0, "description", editor.getData())
                                            }
                                            config={{
                                                toolbar: [
                                                    "undo", "redo", "|",
                                                    "heading", "|",
                                                    "bold", "italic", "underline", "|",
                                                    "bulletedList", "numberedList",
                                                ],
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* RIGHT */}
                            <div className="aboutus-right">

                                <div className="image-row">

                                    {/* IMAGE 1 */}
                                    <div className="image-box">
                                        <label>Image 1</label>
                                        <div className="ourgallery-upload-box">
                                            {imagePreview1 ? (
                                                <img src={imagePreview1} className="preview-img" />
                                            ) : (
                                                <>
                                                    <img src={UploadIcon} className="upload-icon" />
                                                    <p>Upload</p>
                                                </>
                                            )}
                                            <input type="file" accept="image/*" onChange={handleImage1Upload} />
                                        </div>
                                    </div>

                                    {/* IMAGE 2 */}
                                    <div className="image-box">
                                        <label>Image 2</label>
                                        <div className="ourgallery-upload-box">
                                            {imagePreview2 ? (
                                                <img src={imagePreview2} className="preview-img" />
                                            ) : (
                                                <>
                                                    <img src={UploadIcon} className="upload-icon" />
                                                    <p>Upload</p>
                                                </>
                                            )}
                                            <input type="file" accept="image/*" onChange={handleImage2Upload} />
                                        </div>
                                    </div>

                                </div>

                                {/* TITLE 2 */}
                                {formData.aboutusData[1] && (
                                    <div className="news-form-group aboutus-editor-small">
                                        <div className="aboutus-form-group">
                                            <label>Our Value <span className="required">*</span></label>
                                            <input
                                                style={{ width: "auto" }}
                                                type="text"
                                                value={formData.aboutusData[1].heading}
                                                onChange={(e) =>
                                                    handleTitleChange(1, "heading", e.target.value)
                                                }
                                            />
                                        </div>
                                        <label>Description <span className="required">*</span></label>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={formData.aboutusData[1].description}
                                            onChange={(e, editor) =>
                                                handleTitleChange(1, "description", editor.getData())
                                            }
                                            config={{
                                                toolbar: [
                                                    "undo", "redo", "|",
                                                    "heading", "|",
                                                    "bold", "italic", "underline", "|",
                                                    "bulletedList", "numberedList",
                                                ],
                                            }}
                                        />
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </>
            )}
            {showPreviewAboutUs && (
                <AboutUsPreview
                    previewService={previewData}
                    setShowPreviewAboutUs={setShowPreviewAboutUs}
                />
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                      <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/aboutus");
                                    }
                                }}
                            >
                                OK
                            </button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default AboutUsEdit;
